module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component component-backoffice-driver"
  }, [(_vm.$is('expanded')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('p', [_vm._v("status: " + _vm._s(_vm.item.status))]), _c('p', [_vm._v("expiry " + _vm._s(_vm.item.expiry_date))]), _c('p', [_vm._v("issuer.by " + _vm._s(_vm.item.issuer))]), _c('p', [_vm._v("issuer.date " + _vm._s(_vm.item.issue_date))]), _c('p', [_vm._v("issuer_country " + _vm._s(_vm.item.issuer_country))]), _vm._l((_vm.item.attachments), function(i, index) {
    return _c('button', {
      staticClass: "button secondary block-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.openUrl(i.url)
        }
      }
    }, [_vm._v(_vm._s(i.mime))])
  })], 2) : _vm._e(), (_vm.$is('license-card')) ? _c('div', {
    staticClass: "license-card"
  }, [_c('span', [_vm._v("Driver License")]), _c('pre', [_vm._v(_vm._s(_vm.item))])]) : _vm._e(), (_vm.$is('license-card-accordion')) ? _c('div', {
    staticClass: "license-card-accordion"
  }, [_c('ul', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "accordion",
    attrs: {
      "data-accordion": "data-accordion",
      "data-allow-all-closed": "true"
    }
  }, [_c('li', {
    staticClass: "accordion-item",
    attrs: {
      "data-accordion-item": "data-accordion-item"
    }
  }, [_c('a', {
    staticClass: "accordion-title",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('h3', [_vm._v(_vm._s(_vm.item.type.name))]), (_vm.item.type.has_number) ? _c('h2', [_vm._v(_vm._s(_vm.item.number))]) : _vm._e(), (_vm.item.type.has_issuer) ? _c('p', [_vm._v("ISSUED ON:"), _c('b', [_vm._v(_vm._s(_vm.item.issue_date))])]) : _vm._e(), (_vm.item.type.has_number) ? _c('p', [_vm._v("NUMBER:"), _c('b', [_vm._v(_vm._s(_vm.item.number))])]) : _vm._e()]), _c('div', {
    staticClass: "columns"
  }, [_c('p', [_c('strong', [_vm._v("CREATED: " + _vm._s(_vm.item.created_at))])]), (_vm.item.type.has_expiry) ? _c('p', [_c('strong', [_vm._v("EXPIRY DATE: " + _vm._s(_vm.item.expiry_date))])]) : _vm._e(), _c('p', [_c('strong', [_vm._v("STATUS: " + _vm._s(_vm.item.status))])])])])]), _c('div', {
    staticClass: "accordion-content",
    attrs: {
      "data-tab-content": "data-tab-content"
    }
  }, [_c('dropdown', {
    staticClass: "float-right",
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('div', {
    staticClass: "flex-container flex-dir-column"
  }, [(_vm.item.status !== 'VALID') ? _c('a', {
    staticClass: "success-text",
    on: {
      "click": _vm.approve
    }
  }, [_vm._v("Approve")]) : _vm._e(), _c('div', {
    staticClass: "warning-text",
    on: {
      "click": _vm.refuse
    }
  }, [_vm._v("Refuse")]), _c('hr', {
    staticClass: "dropdown-separator"
  }), _c('a', {
    staticClass: "warning-text",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]), _c('a', {
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Upload")]), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": _vm.deleteD
    }
  }, [_vm._v("Delete")])])]), (_vm.item.type.has_issuer) ? _c('p', [_vm._v("Issued by:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.issuer))])]) : _vm._e(), (_vm.item.type.has_country) ? _c('p', [_vm._v("Issuer country:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.issuer_country))])]) : _vm._e(), (_vm.item.type.has_emission) ? _c('p', [_vm._v("Issued date:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.issue_date))])]) : _vm._e(), (_vm.item.type.has_number) ? _c('p', [_vm._v("Number:"), _c('b', [_vm._v(" " + _vm._s(_vm.item.number))])]) : _vm._e(), (_vm.item.attachments.length) ? _c('hr') : _c('p', {
    staticClass: "text-center alert-text no-attachments"
  }, [_vm._v("no attachments")]), _c('backoffice-driver-license-attachment', {
    attrs: {
      "item": _vm.item
    }
  })], 1)])])]) : _vm._e(), (_vm.$is('license-approval-list')) ? _c('div', {
    staticClass: "license-approval-list"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('CardN', {
    attrs: {
      "columns": 4,
      "showAction": true,
      "showBullets": true
    }
  }, [_c('dropdown', {
    attrs: {
      "slot": "actionBullets",
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    },
    slot: "actionBullets"
  }, [_c('div', {
    staticClass: "flex-container flex-dir-column"
  }, [(_vm.item.status !== 'VALID') ? _c('a', {
    staticClass: "success-text",
    on: {
      "click": _vm.approve
    }
  }, [_vm._v("Approve")]) : _vm._e(), _c('div', {
    staticClass: "warning-text",
    on: {
      "click": _vm.refuse
    }
  }, [_vm._v("Refuse")]), _c('hr', {
    staticClass: "dropdown-separator"
  }), _c('a', {
    staticClass: "warning-text",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Edit")]), _c('a', {
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Upload")]), _c('a', {
    staticClass: "alert-text",
    on: {
      "click": _vm.deleteD
    }
  }, [_vm._v("Delete")])])]), _c('span', {
    attrs: {
      "slot": "n1"
    },
    slot: "n1"
  }, [_vm._v("D" + _vm._s(_vm.item.id))]), _c('driver-fields', {
    attrs: {
      "slot": "n1",
      "item": _vm.item.driver,
      "fieldName": 'driver-info'
    },
    slot: "n1"
  }), _c('div', {
    staticClass: "document-info",
    attrs: {
      "slot": "n2"
    },
    slot: "n2"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.item.type.name))])]), (_vm.item.type.has_number) ? _c('span', [_vm._v("Number: " + _vm._s(_vm.item.number))]) : _vm._e(), (_vm.item.type.has_expiry) ? _c('span', [_vm._v("Expiry: " + _vm._s(_vm.item.expiry_date))]) : _vm._e(), (_vm.item.type.has_emission) ? _c('span', [_vm._v("Emission: " + _vm._s(_vm.item.issue_date))]) : _vm._e()]), _c('div', {
    staticClass: "document-info",
    attrs: {
      "slot": "n3"
    },
    slot: "n3"
  }, [(_vm.item.type.has_issuer) ? _c('span', [_vm._v("Issuer: " + _vm._s(_vm.item.issuer)), (_vm.item.type.has_country) ? _c('span', [_vm._v(" " + _vm._s(_vm.item.issuer_country))]) : _vm._e()]) : _vm._e(), _c('span', [_vm._v("Created: " + _vm._s(_vm.item.created_at))])]), _c('div', {
    staticClass: "attachments",
    attrs: {
      "slot": "actionPage"
    },
    slot: "actionPage"
  }, [_c('span', {
    staticClass: "fa",
    class: _vm.attachmentButton,
    on: {
      "click": function($event) {
        _vm.showAttachments = !_vm.showAttachments
      }
    }
  })])], 1)], 1)]), (_vm.showAttachments) ? _c('div', {
    staticClass: "attachments inner-content"
  }, [(_vm.item.attachments.length) ? _c('hr') : _c('p', {
    staticClass: "text-center alert-text no-attachments"
  }, [_vm._v("no attachments")]), _c('backoffice-driver-license-attachment', {
    attrs: {
      "item": _vm.item
    }
  }), _c('div', {
    staticClass: "row align-justify"
  }, [_c('h3', [(_vm.item.status !== 'VALID') ? _c('a', {
    staticClass: "success-text",
    on: {
      "click": _vm.approve
    }
  }, [_vm._v("Approve")]) : _vm._e()]), _c('h3', [_c('a', {
    staticClass: "warning-text",
    on: {
      "click": _vm.refuse
    }
  }, [_vm._v("Refuse")])])])], 1) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-563e1b22!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverLicence.vue
// module id = 2504
// module chunks = 1